( function () {
   
    'use strict';

    ( function ( $ ) {
        	
        
       
        $(".videos-play-two").click(function (e) {
            e.stopPropagation();
            $("#overlay-bg-two").addClass('active');
            $('#videos-two').trigger('play');
        });
        $(".videos-play-three").click(function (e) {
            e.stopPropagation();
            $("#overlay-bg-three").addClass('active');
            $('#videos-three').trigger('play');
        });

        $('.banner-video-play-slider').slick({
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:false,
            fade: true,
            autoplaySpeed: 2000,
            arrows:false,
           
        });

        $('.buy-tickets-popup-video-overlay-one').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
              open: function() {
                $("body").addClass("overflow");
                $(this.content).find('video')[0].play();
             },
              close: function() {
                $("body").removeClass("overflow");
                jQuery(this.content).find('video')[0].pause();
              }
            }
        });
    } )(jQuery);
} )();

